export enum AdminAddAdminFormItemName {
  Email = "email",
  FirstName = "firstName",
  LastName = "lastName",
}
